import { ActionType, ProTable } from "@ant-design/pro-components";
import { useGlobalState } from "../../components/global";
import { useEffect, useRef, useState } from "react";
import UUIDComponent from "../../components/UUIDComponent";
import { Button, Form, message, Modal, Popconfirm } from "antd";
import GlobalWrap from "../../components/globalWrap";
import { PlusOutlined } from "@ant-design/icons";
import { useParams } from "react-router-dom";
import HealthTempForm from "./HealthTempForm";

export default function HealthTemp() {
    const { jsonRequest } = useGlobalState();
    const { id: taskId } = useParams<{ id: string }>();
    const tableRef = useRef<ActionType>();
    const [tempType, setTempType] = useState<any[]>([]);
    const [form] = Form.useForm();

    const getTempType = async () => {
        await jsonRequest.get('/back/daily/heath/dict', {
            dictGroup: 'DAILY_TASK_TEMP_TYPE',
        })
            .then((resp: any) => resp.json())
            .then((data: any) => {
                if (data?.code === 0) {
                    setTempType(data?.data || []);
                } else {
                    message.error(data?.msg || "获取模版类型失败");
                }
            });
    }

    useEffect(() => {
        tableRef.current?.reload();
        getTempType();
    }, []);

    const columns: any[] = [
        {
            title: "序号",
            valueType: "index",
            search: false,
            align: "center",
        },
        {
            title: "ID",
            dataIndex: "id",
            align: "center",
            search: false,
            render: (value: any) => <UUIDComponent value={value} />
        },
        {
            title: "任务组ID",
            dataIndex: "taskId",
            align: "center",
            search: false,
            render: (value: any) => <UUIDComponent value={value} />
        },
        {
            title: "标题",
            dataIndex: "title",
            align: "center",
            search: false,
        },
        {
            title: "模版类型",
            dataIndex: "tempType",
            align: "center",
            search: false,
            render: (text: any) => {
                let item = tempType.find((item: any) => item.dictKey === text);
                return item?.dictValue || '-';
            }
        },
        {
            title: "模版数据",
            dataIndex: "data",
            align: "center",
            search: false,
            render: (text: any) => <Button type="link" onClick={() => {
                Modal.info({
                    title: '模版数据',
                    width: 800,
                    content: (
                        <pre style={{
                            backgroundColor: '#f5f5f5',
                            padding: '16px',
                            borderRadius: '4px',
                            maxHeight: '400px',
                            overflow: 'auto',
                            whiteSpace: 'pre-wrap',
                            wordBreak: 'break-all'
                        }}>
                            {JSON.stringify(text, null, 2)}
                        </pre>
                    ),
                    maskClosable: true,
                });
            }}>详情</Button>,
        },
        {
            title: "备注",
            dataIndex: "remark",
            align: "center",
            search: false,
        },
        {
            title: "循环周期",
            dataIndex: "cyclePeriod",
            align: "center",
            search: false,
            render: (text: number) => text + '天',
        },
        {
            title: "可以完成次数",
            dataIndex: "totalCompletedNumber",
            align: "center",
            search: false,
        },
        {
            title: "最小支持版本号",
            dataIndex: "minVersionCode",
            align: "center",
            search: false,
        },
        {
            title: "最大支持版本号",
            dataIndex: "maxVersionCode",
            align: "center",
            search: false,
        },
        {
            title: "开始时间",
            dataIndex: "startTime",
            align: "center",
            search: false,
        },
        {
            title: "结束时间",
            dataIndex: "endTime",
            align: "center",
            search: false,
        },
        {
            title: "时间备注",
            dataIndex: "timeRemark",
            align: "center",
            search: false,
        },
        {
            title: "操作",
            key: 'operation',
            search: false,
            align: "center",
            render: (_: any, record: any) => <>
                <Button type="link" onClick={() => handleAddOrEdit(record)}>编辑</Button>
                <Popconfirm title="确定删除？" okText="是" cancelText="否"
                    onConfirm={() => deleteHandle(record.id)}>
                    <Button type='link' size='small' danger>删除</Button>
                </Popconfirm>
            </>,
        }
    ];

    const handleAddOrEdit = (item: any) => {
        Modal.confirm({
            width: "60vw",
            title: !!item.id ? `任务模版编辑 - ${item.title}` : "任务模版新增",
            content: <GlobalWrap><HealthTempForm form={form} item={item} tempType={tempType} /></GlobalWrap>,
            onOk: async (close) => {
                let values = await form.validateFields();
                if (item?.id) {
                    values.id = item.id;
                }
                values.taskId = taskId;
                if (values?.startTime) {
                    values.startTime = values.startTime.format('HH:mm');
                }
                if (values?.endTime) {
                    values.endTime = values.endTime.format('HH:mm');
                } else values.endTime = values.startTime;
                console.log(values, 'values');
                await jsonRequest.post("/back/daily/heath/task/temp", {
                    ...values,
                }).then((resp: any) => resp.json())
                    .then((data: any) => {
                        if (data?.code === 0) {
                            message.success(`${!!item.id ? "编辑" : "新增"}成功`);
                        } else {
                            message.error(data?.msg || `${!!item.id ? "编辑" : "新增"}失败`);
                        }
                    }
                    )
                tableRef.current?.reload();
                form.resetFields();
                close();
                return false;
            },
            onCancel: (close) => {
                form.resetFields();
                close();
            }
        })
    }

    const deleteHandle = async (id: any) => {
        const result: any = await jsonRequest.delete(`/back/daily/heath/task/temp/${id}`, {});
        if (result?.body.code === 0)
            message.success('删除成功');
        else {
            message.error('删除失败');
            console.log(result);
        }
        tableRef.current?.reload();
    }

    const request = async () => {
        const result: any = await jsonRequest.get(`/back/daily/heath/task/temp/${taskId}`, {})
            .then((resp: any) => resp.json());
        const { data } = result;
        return { data: data, success: result.code === 0, total: data?.length || 0 };
    };

    return <>
        <h1>任务模版</h1>
        <ProTable
            rowKey="id"
            scroll={{ x: 100 }}
            actionRef={tableRef}
            cardBordered
            columns={columns}
            request={request}
            pagination={false}
            search={{ span: 6, defaultCollapsed: false }}
            toolBarRender={() => [<Button
                key="button"
                icon={<PlusOutlined />}
                onClick={() => handleAddOrEdit({})}
                type="primary"
            >
                新增
            </Button>]}
        />
    </>;
}